// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/devs/projects/sinograin/sinograin-frontend/src/models/useCustomTabs';
import model_2 from '/opt/devs/projects/sinograin/sinograin-frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'useCustomTabs', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
